import React, { useState } from "react"; // 1. On importe useState
import './style.css';
import { Link, useLocation } from "react-router-dom";
import phoenixHeaderLogo from '../../assets/phoenix_logo_white.png';
import phoenixLogo from "../../assets/phoenix_cut.png";
import phoenixColorBands from "../../assets/color_bands_cut.png";

function Header() {
    const location = useLocation();

    // 2. On remplace toutes les références compliquées par une simple variable d'état
    // isOpen est soit true (ouvert), soit false (fermé)
    const [isOpen, setIsOpen] = useState(false);

    // 3. Fonction pour ouvrir/fermer le menu
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // 4. Fonction pour fermer le menu quand on clique sur un lien
    const closeMenu = () => {
        setIsOpen(false);
    };

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <>
            <section id="background-logos-container">
                <img id="background-logo-1" src={phoenixColorBands} alt=""/>
                <div id="background-logos-content">
                    <img id="background-logo-2" src={phoenixLogo} alt=""/>
                </div>
            </section>
            {/*<section id="phoenixLogo"><img src={phoenixLogo} alt=""/></section>
            <section id="phoenixColorBands"><img src={phoenixColorBands} alt=""/></section>*/}
            <header>
            <img src={phoenixHeaderLogo} alt="Phoenix Logo"/>
                <div id="header-title-options">
                    <div id="options">
                        <Link to="/home" className={isActive('/home')}>Accueil</Link>
                        <Link to="/informations" className={isActive('/informations')}>Chartes</Link>
                        <Link to="/inscriptions" className={isActive('/inscriptions')}>Contact</Link>
                        <Link to="/membres" className={isActive('/membres')}>Membres</Link>
                        <Link to="/calendrier" className={isActive('/calendrier')}>Calendrier</Link>
                        <Link to="/documents" className={isActive('/documents')}>Documents</Link>
                        <Link to="/photos" className={isActive('/photos')}>Photos</Link>
                    </div>
                    <h1>Bienvenue dans le groupe Phoenix</h1>
                </div>

                {/* --- LE BURGER --- */}
                <section
                    id="burger"
                    // Si isOpen est vrai, on ajoute la classe "open", sinon rien.
                    // Votre CSS s'occupe de tout le reste (position fixed, croix, rouge, etc.)
                    className={isOpen ? "open" : ""}
                    onClick={toggleMenu}
                >
                    <div className="menu-bar bar1"></div>
                    <div className="menu-bar bar2"></div>
                    <div className="menu-bar bar3"></div>
                </section>

                {/* --- LE MENU CACHÉ --- */}
                <section
                    id="hidden-menu"
                    // Si isOpen est vrai, on enlève la classe "hidden", sinon on la garde
                    className={isOpen ? "" : "hidden"}
                >
                    <div id="hidden-menu-container">
                        {/* On ajoute closeMenu sur les liens pour que le menu se ferme après le clic */}
                        <Link to="/home" className={isActive('/home')} onClick={closeMenu}>Accueil</Link>
                        <Link to="/informations" className={isActive('/informations')}
                              onClick={closeMenu}>Chartes</Link>
                        <Link to="/inscriptions" className={isActive('/inscriptions')}
                              onClick={closeMenu}>Contact</Link>
                        <Link to="/membres" className={isActive('/membres')} onClick={closeMenu}>Membres</Link>
                        <Link to="/calendrier" className={isActive('/calendrier')} onClick={closeMenu}>Calendrier</Link>
                        <Link to="/documents" className={isActive('/documents')} onClick={closeMenu}>Documents</Link>
                        <Link to="/photos" className={isActive('/photos')} onClick={closeMenu}>Photos</Link>
                    </div>
                </section>
            </header>
        </>
    );
}

export default Header;